/**
 * reportAuthError — Beklenmeyen auth ALTYAPI hatasını ErrorLog'a raporla (SSoT)
 * =============================================================================
 * Supabase auth çağrıları (login/register/googleLogin/updateUser/resetPassword/callback) axios
 * DIŞINDA çalışır → axios response-interceptor bunları GÖRMEZ (observability kör-noktası). Bu helper
 * o kör-noktayı kapatır: gerçek sorunları (5xx + ağ + 429 rate-limit) ErrorLog'a yazar. Ağ hatası oturum başına
 * tek kayıt olarak baglantiRaporu üzerinden gider.
 *
 * Beklenen KULLANICI hataları HARİÇ (gürültü yapma): 400-499 (429 değil) — yanlış şifre, e-posta
 * zaten kayıtlı, geçersiz/expired kod/link vb. Bunlar kullanıcıya mesaj olarak gösterilir, log'a değil.
 *
 * Tek SSoT — AuthContext + auth sayfaları (update-password/callback/reset-password) hepsi bunu çağırır
 * (elle kopya YASAK; drift olursa bir yüzey sessiz kalır).
 *
 * @param {any} error Supabase AuthError / genel hata (error.status / statusCode okunur)
 * @param {string} context 'login'|'register'|'googleLogin'|'updatePassword'|'callback'|'resetPassword'|...
 * @param {object} [extra] ek metadata (email HARİÇ — PII log'a yazma)
 */
import { logErrorToBackend } from '@/shared/utils/errorLogger';
import { baglantiKurulamadi } from '@/shared/utils/baglantiRaporu';

interface AuthErrorLike {
  status?: number;
  statusCode?: number;
  response?: { status?: number };
  name?: string;
  message?: string;
  stack?: string;
}

export function reportAuthError(
  error: AuthErrorLike,
  context: string,
  extra: Record<string, unknown> = {},
): void {
  try {
    const status = error?.status ?? error?.statusCode ?? error?.response?.status ?? null;
    const isExpected = status != null && status >= 400 && status < 500 && status !== 429;
    if (isExpected) return; // beklenen kullanıcı hatası → raporlama (gürültü)
    // Ağ hatası (Supabase'e hiç ulaşılamadı): oturum başına TEK kayıt, www üzerinden (baglantiRaporu SSoT) —
    // her denemede ayrı satır yazmaz; API alan adı da engelliyse kayıt yine varır.
    if (error?.name === 'AuthRetryableFetchError' || status === 0) {
      baglantiKurulamadi('giris', { baglam: context });
      return;
    }
    // Supabase e-posta gönderim throttle'ı ("For security purposes, you can only request this
    // after N seconds" / over_email_send_rate_limit) 429 döner AMA beklenen kullanıcı friction'ı
    // (yeniden-gönder'e hızlı basma) → sistem sorunu DEĞİL. UI cooldown gösterir (useResendCooldown);
    // ErrorLog'a YAZMA (canlı gürültü, 2026-08-26). Diğer 429'lar (backend abuse) loglanmaya devam.
    // SADECE yük-taşıyan iki token (GoTrue kesin kimliği) — "for security purposes" fazlalıktı
    // (gelecekte MFA/step-up "For security purposes…" hatasını yanlışlıkla gizlerdi) ve "email rate
    // limit" GoTrue string'i değil (ölü token). 3-agent review daralttı (2026-08-26).
    const _msg = String(error?.message || '');
    if (/only request this after|over_email_send/i.test(_msg)) return;
    logErrorToBackend({
      errorType: `Auth:${context}`,
      errorMessage: error?.message || 'Bilinmeyen auth hatası',
      errorStack: error?.stack || null,
      metadata: { source: 'supabase-auth', context, status, ...extra },
    });
  } catch {
    /* observability ASLA auth akışını bozmaz */
  }
}

export default reportAuthError;
